import type { PortfolioCategory } from '@repo/api-contracts';
import { usePortfolioCategoriesQuery } from '@/entities/portfolio';
import { Button } from '@/shared/ui';

export const PortfolioCategoryField = ({
  ids,
  existingCategories = [],
  disabled,
  onChange,
}: {
  ids: string[];
  existingCategories?: readonly PortfolioCategory[];
  disabled?: boolean;
  onChange: (ids: string[]) => void;
}) => {
  const query = usePortfolioCategoriesQuery();
  const categories = [
    ...(query.data?.items ?? []),
    ...existingCategories.filter(
      (category) => !query.data?.items.some(({ id }) => id === category.id),
    ),
  ];
  return (
    <fieldset disabled={disabled} className="space-y-2">
      <legend className="font-medium">카테고리 (필수)</legend>
      {query.isPending ? <p>카테고리를 불러오는 중…</p> : null}
      {query.isError ? (
        <div>
          <p role="alert">카테고리를 불러오지 못했습니다.</p>
          <Button type="button" variant="outline" size="sm" onClick={() => void query.refetch()}>
            카테고리 다시 불러오기
          </Button>
        </div>
      ) : null}
      <div className="flex flex-wrap gap-4">
        {categories.map((category) => (
          <label key={category.id} className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={ids.includes(category.id)}
              onChange={(event) =>
                onChange(
                  event.target.checked
                    ? [...ids, category.id]
                    : ids.filter((id) => id !== category.id),
                )
              }
            />
            {category.name}
          </label>
        ))}
      </div>
      {!query.isPending && !query.isError && categories.length === 0 ? (
        <p>등록된 카테고리가 없습니다.</p>
      ) : null}
    </fieldset>
  );
};
